import { useContext } from "react";
import { trans } from "@/service/i18n/i18n";
import { UserContext } from "@/contexts/user-context";
import { Button } from "@/components/ui/button";
import { createPath } from "@/service/routing/routing";
import { SuperLink as Link } from "@/components/common/super-link";

export const Consumer = () => {
  const user = useContext(UserContext);

  return (
    <>
      <h2
        className={`text-card-foreground mb-6 text-center text-2xl font-semibold`}
      >
        {trans("hello")} {user.shortName},
      </h2>
      <p className={`text-foreground mb-6 text-center text-base font-normal`}>
        {trans("permission.dead_end.consumer.desc")}
      </p>

      <Button asChild={true} className={"mb-4 w-full"}>
        <Link href={createPath("homepage")}>{trans("back_to_main_page")}</Link>
      </Button>
    </>
  );
};
